import "../css/adminSignalTest.css";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import Button from "@mui/material/Button";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

import {
  selectDownload,
  selectUpload,
  selectSpeedTest,
} from "../store/selectors/admin";
import {
  setSignalDownload,
  setSignalUpload,
  setSignalSpeedTest,
} from "../store/actions/admin";
import axios from "axios";

let ascRef = React.createRef();

const AntennaSignalSpeedTest = (props) => {
  const dispatch = useDispatch();
  const speedTest = useSelector(selectSpeedTest);
  const download = useSelector(selectDownload);
  const upload = useSelector(selectUpload);
  let evtSource;
  const modemTag = props.tag;

  const getDownload = async () => {
    dispatch(setSignalDownload("loading"));
    dispatch(setSignalUpload("loading"));
    let speedTestState = {
      mainState: "Connecting",
      downState: "idle",
      upState: "idle",
      downSpeed: null,
      upSpeed: null,
      downJitter: null,
      upJitter: null,
      downLatency: null,
      upLatency: null,
      downPacketLoss: null,
      upPacketLoss: null,
    };
    try {
      await fetchEventSource(
        "https://gznendpointapi.azurewebsites.net/api/speedtest2",
        {
          headers: {
            device_type: "modem",
            asset: modemTag,
            "Content-Type": "application/json",
          },
          onmessage(ev) {
            if (ev.data.length > 0) {
              let speedTeststream = JSON.parse(ev.data);
              if (
                speedTeststream.state === "init" &&
                speedTestState.mainState !== "Initializing"
              ) {
                speedTestState = {
                  mainState: "Initializing",
                  downState: "idle",
                  upState: "idle",
                  downSpeed: null,
                  upSpeed: null,
                  jitter: null,
                  latency: null,
                  packetLoss: null,
                };
                dispatch(setSignalSpeedTest(speedTestState));
              } else if (
                speedTeststream.state === "start" &&
                speedTestState.mainState !== "Starting download test"
              ) {
                speedTestState = {
                  mainState: "Starting download test",
                  downState: "idle",
                  upState: "idle",
                  downSpeed: null,
                  upSpeed: null,
                  jitter: null,
                  latency: null,
                  packetLoss: null,
                };
                dispatch(setSignalSpeedTest(speedTestState));
              } else if (
                speedTeststream.state === "running" &&
                speedTeststream.direction === "download"
              ) {
                speedTestState = {
                  ...speedTestState,
                  mainState: "Testing download",
                  downState: "running",
                  upState: "idle",
                  downSpeed: `${Math.round(parseInt(speedTeststream.speed))} ${
                    speedTeststream.rate
                  }`,
                  downHigh: `${Math.round(parseInt(speedTeststream.high))}`,
                  downLow: `${Math.round(parseInt(speedTeststream.low))}`,
                  upSpeed: null,
                  jitter: null,
                  latency: null,
                  packetLoss: null,
                };
                dispatch(setSignalSpeedTest(speedTestState));
              } else if (
                speedTeststream.state === "done" &&
                speedTeststream.direction === "download" &&
                speedTestState.mainState !== "Starting upload test"
              ) {
                speedTestState = {
                  ...speedTestState,
                  mainState: "Starting upload test",
                  downState: "done",
                  upState: "starting",
                  downSpeed: `${Math.round(parseInt(speedTeststream.speed))} ${
                    speedTeststream.rate
                  }`,
                  downHigh: `${Math.round(parseInt(speedTeststream.high))}`,
                  downLow: `${Math.round(parseInt(speedTeststream.low))}`,
                  jitter: null,
                  latency: null,
                  packetLoss: null,
                };
                dispatch(setSignalSpeedTest(speedTestState));
              } else if (
                speedTeststream.state === "running" &&
                speedTeststream.direction === "upload"
              ) {
                speedTestState = {
                  ...speedTestState,
                  mainState: "Testing upload",
                  downState: "done",
                  upState: "running",
                  upSpeed: `${Math.round(parseInt(speedTeststream.speed))} ${
                    speedTeststream.rate
                  }`,
                  upHigh: `${Math.round(parseInt(speedTeststream.high))}`,
                  upLow: `${Math.round(parseInt(speedTeststream.low))}`,
                  jitter: null,
                  latency: null,
                  packetLoss: null,
                };
                dispatch(setSignalSpeedTest(speedTestState));
              } else if (
                speedTeststream.state === "done" &&
                speedTeststream.direction === "upload" &&
                speedTestState.mainState !== "Completed"
              ) {
                speedTestState = {
                  ...speedTestState,
                  mainState: "Completed",
                  upState: "done",
                  upSpeed: `${Math.round(parseInt(speedTeststream.speed))} ${
                    speedTeststream.rate
                  }`,
                  upHigh: speedTeststream.high,
                  upLow: speedTeststream.low,
                  jitter: speedTeststream.jitter,
                  latency: `${Math.round(parseInt(speedTeststream.latency))}ms`,
                  packetLoss: `${speedTeststream.packet_loss}%`,
                };
                dispatch(setSignalSpeedTest(speedTestState));
              }
            }
          },
          onerror(err) {
            console.log(err);
          },
        }
      );
      // const newConnection = () => {
      //   evtSource = new EventSource(
      //     "https://gznendpointapi.azurewebsites.net/api/speedtest2",
      //     {
      //       withCredentials: false,
      // headers: {
      //   device_type: "modem",
      //   asset: "GZN01735",
      //   "Content-Type": "application/json",
      // },
      //     }
      //   );
      // };
      // newConnection();
      // let res1 = await axios.post(
      //   "https://gznendpointapi.azurewebsites.net/api/speedtest",
      //   { modem: modemTag, direction: "download" },
      //   {}
      // );
      // console.log(res1, "res1");

      // let res2 = await axios.get(
      //   "https://gznendpointapi.azurewebsites.net/api/speedtest2",
      //   {
      // headers: {
      //   device_type: "modem",
      //   asset: "GZN01735",
      //   "Content-Type": "application/json",
      // },
      //   }
      // );
      // console.log(res2);
      // res2.onmessage = (event) => {
      //   console.log(event);
      // };
      // const reader = res2.pipeThrough(new TextDecoderStream()).getReader();
      // console.log(await reader);
      // console.log(await reader.read());
      // while (true) {
      //   const { value, done } = await reader.read();
      //   console.log(await reader.read());
      //   if (done) break;
      //   //   console.log("Received", value);
      // }
      // console.log(res2, "res2");
      // console.log(reader);
      // if (
      //   res1.data.download_average === "0" ||
      //   Object.keys(res1.data)[0] === "error" ||
      //   Object.keys(res1.data)[0] === "ERROR"
      // ) {
      //   setTimeout(() => {
      //     getDownload();
      //   }, "1000");
      // } else {
      //   console.log("download:", res1.data);
      //   dispatch(setSignalDownload(res1.data.download_receive));
      //   setTimeout(() => {
      //     getUpload();
      //   }, "1000");
      // }
    } catch (e) {
      // setTimeout(() => {
      //   getDownload();
      // }, "1000");
    }
  };
  // const getUpload = async () => {
  //   console.log(modemTag, props);
  //   dispatch(setSignalUpload("loading"));
  //   try {
  //     let res1 = await axios.post(
  //       "https://gznendpointapi.azurewebsites.net/api/speedtest",
  //       { modem: modemTag, direction: "upload" },
  //       {}
  //     );
  //     if (
  //       res1.data.upload_average === "0" ||
  //       Object.keys(res1.data)[0] === "error"
  //     ) {
  //       setTimeout(() => {
  //         getUpload();
  //       }, "1000");
  //     } else {
  //       dispatch(setSignalUpload(res1.data.upload_send));
  //       console.log("upload:", res1.data);
  //     }
  //   } catch (e) {
  //     setTimeout(() => {
  //       getUpload();
  //     }, "1000");
  //   }
  // };
  return (
    <div ref={ascRef} className={"antennaSigSpeed"}>
      <div>
        <Button
          disabled={
            speedTest.mainState !== "Completed" &&
            speedTest.mainState !== "idle"
          }
          variant="contained"
          sx={{
            fontFamily: "Quenda, serif !important",

            background: "#4ab217",
            color: "white",
            width: "125px",
            ":hover": {
              bgcolor: "#4ab217",
              color: "white",
            },
            ":disabled": {
              color: "white",
            },
          }}
          onClick={(e) => {
            dispatch(
              setSignalSpeedTest({
                mainState: "Connecting",
                downState: "idle",
                upState: "idle",
                downSpeed: null,
                downHigh: null,
                upSpeed: null,
                upHigh: null,
                jitter: null,
                latency: null,
                packetLoss: null,
              })
            );
            getDownload();
          }}
        >
          Speed test
        </Button>
      </div>
      {download && upload ? (
        <div className="speedResults">
          <div>{speedTest.mainState}</div>
          <div>{`${
            speedTest.downSpeed ? `Download: ${speedTest.downSpeed} ` : "-"
          } ${
            speedTest.downHigh && speedTest.downLow
              ? `(${speedTest.downLow}-${speedTest.downHigh})`
              : ""
          }`}</div>
          <div>{`${
            speedTest.upSpeed ? `Upload: ${speedTest.upSpeed} ` : "-"
          }  ${
            speedTest.upHigh && speedTest.upLow
              ? `(${speedTest.upLow}-${speedTest.upHigh})`
              : ""
          }`}</div>
          <div>{`${speedTest.jitter ? `Jitter: ${speedTest.jitter} ` : "-"} ${
            speedTest.latency ? `Latency: ${speedTest.latency} ` : "-"
          } ${
            speedTest.packetLoss ? `Packet loss: ${speedTest.packetLoss} ` : "-"
          }
          `}</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default AntennaSignalSpeedTest;
